import $ from 'jquery';
import {isEmpty,root,locale} from '../Helpers';
import {EVENT_TOGGLE_TOOLBAR} from '../Params';

export default  class ToggleButton{
    constructor(){
        this._data ={};
        this.render()
    }

    get elem(){ return this._data.elem}
    set elem(x){ this._data.elem = x }

    get position(){ return this._data.position}
    set position(pos){ this._data.position = pos }

    get visible(){ return this._data.visible}
    set visible(x){
        if(isEmpty(this.elem)){return}
        if(this._data.visible===x){return}
        this._data.visible =x;
        this.elem.toggle(x)
    }


    render(){
        this.elem = $('<button>',{
            id: "acc-toggle-toolbar",
            'aria-label' : locale('open_acc_menu')
        })

        this.elem.html($('<img src="'+locale('acc_icon')+'"  alt=""/>'));
        this.elem.click(() =>  $(document).trigger(EVENT_TOGGLE_TOOLBAR))
        return this.elem
    }

}